import React from 'react';

import SidebarButton from './SidebarButton';
import SidebarManagementGroup from './SidebarManagementGroup';

import { SIDEBAR_BUTTONS, SIDEBAR_MANAGEMENT_GROUP } from '../../utils/constants';
import { useAdminPermissions } from 'src/hooks/useAdminPermissions';

import { StyledSidebar, StyledList } from './styled';

type SidebarProps = {
  isOpen: boolean;
  onNavigate: () => void;
};

const Sidebar: React.FC<SidebarProps> = ({ isOpen, onNavigate }) => {
  const { can } = useAdminPermissions();

  const visibleButtons = SIDEBAR_BUTTONS.filter(({ permission }) => can(permission));

  return (
    <StyledSidebar id="sidebar" $isOpen={isOpen} aria-hidden={!isOpen}>
      <StyledList>
        {visibleButtons.map(({ text, url, img }) => (
          <li key={text}>
            <SidebarButton text={text} src={img} url={url} onNavigate={onNavigate} />
          </li>
        ))}
        <SidebarManagementGroup group={SIDEBAR_MANAGEMENT_GROUP} onNavigate={onNavigate} />
      </StyledList>
    </StyledSidebar>
  );
};

export default Sidebar;
